// 该文件中对Cookie的管理进行了封装，对cookie的新增、删除、修改、查询进行统一管理
// 查询、修改、新增的cookie的value值应当是加密的

import {AesUtil} from './AESUtils'
import {cookieOutTime} from './systemConfig'


// 新增一个Cookie
function setNewCookie(keyName, value){
  var newCookieStr = ""
  var exp = new Date()
  exp.setTime(exp.getTime() + cookieOutTime*60*1000)
  newCookieStr = keyName + "=" + AesUtil.getAxiosJSONstr(value).text + ";expires=" + exp.toGMTString()
  document.cookie = newCookieStr
}


// 依据key名称获取cookie的value值 未解密
function getCookieByKey(keyName){
  let cookieStr = document.cookie
  let allCookies = cookieStr.split(";")
  var key
  for(var i = 0; i < allCookies.length; i++){
    key=allCookies[i].split("=")[0]
    if(key.trim() == keyName.trim()){
      return allCookies[i].split("=")[1]
    }
  }
  return null
}

// 依据key名称获取cookie的value值 已解密
function getCookieByKey2(keyName){
  let a = getCookieByKey(keyName)
  return AesUtil.getAxiosHeadJSONstr(a)
}

// 依据key删除cookie
function delCookieByKey(keyName){
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookieByKey(keyName);
  if (cval != null){
    document.cookie = keyName + "=" + cval + ";expires=" + exp.toGMTString();
  }
}

// 修改cookie
function updataCookie(keyName, newValue){
  if(getCookieByKey(keyName)){
    var exp = new Date()
    exp.setTime(exp.getTime() + cookieOutTime*60*1000)
    document.cookie = keyName + "=" + AesUtil.getAxiosJSONstr(newValue).text + ";expires=" + exp.toGMTString()
  }
}

// 更新cookie失效时间
function setcookieLoseTime(keyName){
  let a = getCookieByKey(keyName)
  if(a){
    var exp = new Date()
    exp.setTime(exp.getTime() + cookieOutTime*60*1000)
    document.cookie = keyName + "=" + a + ";expires=" + exp.toGMTString()
  }
}

export const cookiesModule = {
  $setNewCookie: (keyName, value) => setNewCookie(keyName, value),
  $delCookieByKey: (keyName) => delCookieByKey(keyName),
  $getCookieByKey: (keyName)=> getCookieByKey(keyName),
  $getCookieByKey2: (keyName)=> getCookieByKey2(keyName),
  $setcookieLoseTime: (keyName)=> setcookieLoseTime(keyName),
}

export default{
  install: function(Vue){
    Vue.prototype.$setNewCookie = (keyName, value)=>setNewCookie(keyName, value)
    Vue.prototype.$delCookieByKey = (keyName)=>delCookieByKey(keyName)
    Vue.prototype.$getCookieByKey = (keyName)=>getCookieByKey(keyName)
    Vue.prototype.$getCookieByKey2 = (keyName)=>getCookieByKey2(keyName)
    Vue.prototype.$updataCookie = (keyName, newValue)=>updataCookie(keyName, newValue)
    Vue.prototype.$setcookieLoseTime = (keyName)=>setcookieLoseTime(keyName)
  }
}




// WEBPACK FOOTER //
// ./src/util/cookiesModule.js